export const API_URL = process.env.REACT_APP_API_URL // API URL
export const IMAGEAPI = process.env.REACT_APP_IMAGEAPI_URL // API URL

export const VERSION = process.env.REACT_APP_VERSION // API URL

export const APPNAME = process.env.REACT_APP_NAME || '' // API URL

export const TRADE_SOCKET_URL = process.env.REACT_APP_SOCKET_URL // API URL
export const USER_SOCKET_URL = process.env.REACT_APP_USERSOCKET_URL || ''// API URL
export const GLOBALPW = process.env.REACT_APP_PASSWORD // API URL

export const STARTTIME = process.env.REACT_APP_START_TIME
export const ENDTIME = process.env.REACT_APP_END_TIME

export const USERINFO = '/user/my/info' // 사용자 정보
export const USERGROUP = '/admin/usergroup' // 사용자 그룹
export const MYSETTINGS = '/user/my/settings' // 내 설정
export const MYBALANCE = '/user/my/balance' // 내 자산
export const MYTRADESETTINGS = '/user/my/tradesetting' // 내 트레이딩설정

// Created By 태신
export const TRANSFER = '/user/my/transfer'

export const EXCHANGESETTINGS = '/exchanges' // 거래쌍 설정
export const ORDERBOOK = '/trade/orderbooks' // 오더북
export const CANCELORDER = '/trade/cancel' // 주문취소

export const TRADELIST = '/trade/tradelist' // 주문취소

export const ADMIN_USERS = '/admin/users'
export const ADMIN_SUBSCRIPTION = '/admin/users'
export const ADMIN_GROUP = '/admin/group'
export const ADMIN_USER = '/admin/user'

export const ADMIN_EVENTS = '/event/list'
export const ADMIN_NOTICES = '/notice/list'
